export const GIFT_CARD_TYPE = 'Gift Card';
export const CASH_FUND_TYPE = 'Cash Fund';
export const EXPERIENCES_TYPE = 'Experiences';
export const OPTIONS = {
  SIZE: 'size',
  COLOR: 'color',
  DENOMINATION: 'denomination',
  GENERIC: 'option',
};
export const MAX_COLOR_OPTIONS_DISPLAYED_MOBILE = 3;
export const MAX_COLOR_OPTIONS_DISPLAYED_DESKTOP = 5;
